import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const findingExplorerPlugin = createPlugin({
  id: 'finding-explorer',
  routes: {
    root: rootRouteRef,
  },
});

export const FindingExplorerPage = findingExplorerPlugin.provide(
  createRoutableExtension({
    name: 'FindingExplorerPage',
    component: () =>
      import('./components/FindingExplorerPage').then(
        m => m.FindingExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
